import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import DemoLetter from '../game/DemoLetter';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import ShapeTextButton from '../ui/ShapeTextButton';
import UIAssetKeys from '../UIAssetKeys';
import CreatorScreen from './CreatorScreen';

export default class LearnScreen extends Phaser.Scene
{
    static get KEY() { return 'LearnScreen'; }

    constructor()
    {
        super({ key: (LearnScreen).KEY });
    }

    create()
    {
        this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0xf4805c).setOrigin(0);

        this.screenTitle = this.add.container(this.scale.width/2, (gameData.isMobile) ? 100 : 90).setScale(0).setAlpha(0);
        
        const titleText = ABCyaPhaser.Localization.instance.getLocalizedString('intro.header').split(/\r?\n|\r|\n/g);
        const titleTop = this.add.bitmapText(0,0, 'friendly_letter', titleText[0], 105, 1).setOrigin(.5, 1)
          .setCenterAlign();
        this.screenTitle.add(titleTop);
        const titleBottom = this.add.bitmapText(0,0, 'friendly_letter', titleText[1], 100, 1).setOrigin(.5, 0)
          .setCenterAlign();
        if(titleBottom.width > titleTop.width){
          titleBottom.scale =  titleTop.width / titleBottom.width;
        }
        this.screenTitle.add(titleBottom);

        this.screenTitle.endScale = (gameData.isMobile) ? 1 : 0.85;

        let instSize = (gameData.isMobile) ? 58 : 48;
        let inst1 = ABCyaPhaser.Text.addText(0, 0, instSize, 0xffffff, FontKeys._cardenio_modernregular, ABCyaPhaser.Localization.instance.getLocalizedString('intro.title_1'), this, true);
        inst1.x = (this.scale.width / 2);
        inst1.y = this.screenTitle.y + 65 + (inst1.height / 2) + 0;
        inst1.alpha = 0;

        this.demoLetter = new DemoLetter(this);
        this.demoLetter.x = (this.scale.width / 2) - (this.demoLetter.letterWidth / 2);
        this.demoLetter.y = -(this.demoLetter.letterHeight);
        this.demoLetter.endY = (gameData.isMobile) ? inst1.y + (inst1.height) + 50 : inst1.y + (inst1.height/2)+5;
        this.add.existing(this.demoLetter);

        let inst2Size = (gameData.isMobile) ? 42 : 34;
        let inst2 = ABCyaPhaser.Text.addText(0, 0, inst2Size, 0xffffff, FontKeys._cardenio_modernregular, ABCyaPhaser.Localization.instance.getLocalizedString('intro.title_2'), this, true);
        inst2.x = (this.scale.width / 2);
        inst2.y = (gameData.isMobile) ? this.demoLetter.endY + this.demoLetter.letterHeight + 40 : this.demoLetter.endY + this.demoLetter.letterHeight + 20;
        inst2.alpha = 0;

        this.createBtn = new ShapeTextButton(this, ABCyaPhaser.Localization.instance.getLocalizedString('intro.footer'), 0x3258A7, FontKeys._asapbold, 42, 0xFBE796);
        // original code moved the container registration point, which isn't possible in Phaser, so instead we move all the child gameobjects as needed
        this.createBtn.centerX();
        this.createBtn.disableInteractive();
        this.createBtn.x = (this.scale.width / 2);
        this.createBtn.y = this.scale.height;

        let btnBg = this.add.rectangle(0, this.scale.height, this.scale.width, this.createBtn.getBounds().height + 30, 0x3258a7).setOrigin(0).setInteractive();
        btnBg.y = this.scale.height;

        this.add.existing(btnBg);
        this.add.existing(this.createBtn);
        this.pencil = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._pencil, this).setOrigin(1);
        this.pencil.y = this.demoLetter.y;
        this.pencil.x = (gameData.isMobile) ? this.scale.width / 2 : this.scale.width / 4;

        this.createBtn.bg = btnBg;

        // SR - there is a bug in Phaser 3.55.2 with BitmapFonts and the "max width".
        // The max width seems to take into account the scale, so when scaled down or up, the max width needs to be adjusted so that the text doesn't change
        // the onUpdate function does this
        ABCyaPhaser.Tweens.addTween(this.screenTitle, 500, { alpha: 1, scale: this.screenTitle.endScale, onUpdate: () => {/*this.screenTitle.setMaxWidth(700 * this.screenTitle.scale)*/} }, Phaser.Math.Easing.Quadratic.InOut);

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fast_whoosh_1, this);
        ABCyaPhaser.Tweens.addTween(inst1, 400, { delay: 600, alpha: 1, onStart: () => ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fast_whoosh_2, this) }, Phaser.Math.Easing.Quadratic.Out);
        ABCyaPhaser.Tweens.addTween(inst2, 400, { delay: 1500, alpha: 1, onStart: () => ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fast_whoosh_3, this) }, Phaser.Math.Easing.Quadratic.Out);
        ABCyaPhaser.Tweens.addTween(this.demoLetter, 400, { delay: 800, y: this.demoLetter.endY }, Phaser.Math.Easing.Quadratic.Out);
        ABCyaPhaser.Tweens.addTween(this.pencil, 400, { delay: 800, y: this.scale.height - 85, onStart: () => ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fast_whoosh_4, this) }, Phaser.Math.Easing.Quadratic.Out, () => this.handleScreenReady());
    }

    handleScreenReady()
    {
        ABCyaPhaser.Tweens.addTween(this.pencil, 500, { delay: 100, angle: -34, y: this.pencil.y - 15 }, Phaser.Math.Easing.Quadratic.In);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_whoops, this);

        ABCyaPhaser.Tweens.addTween(this.createBtn, 100, { delay: 100, y: this.scale.height - this.createBtn.getBounds().height - 20 }, Phaser.Math.Easing.Quadratic.Out);
        ABCyaPhaser.Tweens.addTween(this.createBtn.bg, 100, { delay: 100, y: this.scale.height - this.createBtn.getBounds().height - 30 }, Phaser.Math.Easing.Quadratic.Out);
        this.createBtn.bg.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.exitLearnScreen, this);
    }

    exitLearnScreen()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._clickSound, this);
        this.scene.start(CreatorScreen.KEY);
    }
}